import { BehaviorSubject, Observable } from 'rxjs';
import { BaseUxGameListener } from './base-ux-game-listener';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { BlocksListener } from 'src/games/phaserblocks/game/blocks-listener';

export class BlocksUxGameListener extends BaseUxGameListener implements BlocksListener {
  public get gameMultiplier$(): Observable<number> {
    return this.gameMultiplier.asObservable();
  }
  public get gameLevel$(): Observable<number> {
    return this.gameLevel.asObservable();
  }

  private gameMultiplier = new BehaviorSubject<number>(1);
  private gameLevel = new BehaviorSubject<number>(1);

  constructor(private services: UxGameServices) {
    super();
  }

  onMultiplierChange(multiplier: number): void {
    this.gameMultiplier.next(multiplier);
  }

  onLevelChange(level: number): void {
    this.gameLevel.next(level);
  }
}
